module.exports = __webpack_public_path__ + "img/29.230408a3.jpg";